module.exports = __webpack_public_path__ + "static/img/third1_4_active.0b6f7b41.png";